import moment from 'moment'
import 'moment/locale/fr'

const DateComponent = (value, format) => moment(value).format(format || 'lll')
export default DateComponent
